import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumberFromString, CountryCode } from 'libphonenumber-js';

@Pipe({
    name: 'formatPhone',
    standalone: false
})
export class FormatPhonePipe implements PipeTransform {
    transform(value: string | undefined, defaultCountry: CountryCode = 'AR'): string {
        if (!value) return '---'; 
        const phone = parsePhoneNumberFromString(value, defaultCountry);
        return phone?.isValid() ? phone.formatInternational() : '---';
    }
}
